import { dischargeConditionGetDataApi } from "../../Api/Project/DefaultServices/DischargeConditionApi";
import { fetchDischargeConditionsFailure, fetchDischargeConditionsStart, fetchDischargeConditionsSuccess, fetchDischargeConditionSuccessAndSetSelectedDischargeCondition } from "../Slices/DischargeConditionSlice";
import { AppDispatch } from "../Store";


export const fetchAllDischargeCondition = (seriviceId : number) => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchDischargeConditionsStart())
        const data = await dischargeConditionGetDataApi(seriviceId);
        if(data.status){
            dispatch(fetchDischargeConditionsSuccess(data.data || []));
        }else {
            dispatch(fetchDischargeConditionsFailure(data.massage || ''));
        }

    } catch (e) {
        dispatch(fetchDischargeConditionsFailure(e!.toString()));
    }
}


export const fetchAllDischargeConditionAfterView = (seriviceId : number) => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchDischargeConditionsStart())
        const data = await dischargeConditionGetDataApi(seriviceId);
        if(data.status){
            dispatch(fetchDischargeConditionSuccessAndSetSelectedDischargeCondition(data.data || []));
        }else {
            dispatch(fetchDischargeConditionsFailure(data.massage || ''));
        }

    } catch (e) {
        dispatch(fetchDischargeConditionsFailure(e!.toString()));
    }
}